/** Indian digit grouping — ₹1,00,000, not ₹100,000. A contractor reads the first. */
export function inr(value: number | null | undefined, currency = 'INR') {
  if (value === null || value === undefined) return '—';
  const symbol = currency === 'INR' ? '₹' : '';
  return `${symbol}${value.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

/** Compact for tiles: ₹4.2L, ₹1.3Cr — the units this buyer actually speaks. */
export function inrShort(value: number | null | undefined) {
  if (value === null || value === undefined) return '—';
  const n = Math.abs(value);
  if (n >= 1e7) return `₹${(value / 1e7).toFixed(n >= 1e8 ? 0 : 1)}Cr`;
  if (n >= 1e5) return `₹${(value / 1e5).toFixed(n >= 1e6 ? 0 : 1)}L`;
  if (n >= 1e3) return `₹${(value / 1e3).toFixed(0)}k`;
  return `₹${Math.round(value)}`;
}

export const num = (n: number | null | undefined) =>
  n === null || n === undefined ? '—' : n.toLocaleString('en-IN');
